import { $getCategorySelect, $getSubcategorySelect, isShipmentMissingScenario } from "./utils";

const $getSubcategories = () => {
  const $cardBody = document.querySelector(".js-card-body");
  return JSON.parse($cardBody.dataset.subcategories);
};
const $getAllQuantityInputs = () =>
  document.querySelectorAll('input[name*="[request_items_attributes]"][name*="[quantity]"]');
const $getAllUploadButtons = () => document.querySelectorAll(".js-upload-images-btn");

// Track if we were previously in shipment missing mode
let wasShipmentMissing = false;

const setQuantityInputsForShipmentMissing = () => {
  const $quantityInputs = $getAllQuantityInputs();
  $quantityInputs.forEach($input => {
    // Readonly (not disabled) so values are still submitted
    // eslint-disable-next-line no-param-reassign
    $input.value = $input.getAttribute("max") ?? $input.value;
    $input.setAttribute("readonly", "true");
    $input.classList.add("bg-light", "pe-none");
  });
};

const resetQuantityInputs = () => {
  const $quantityInputs = $getAllQuantityInputs();
  $quantityInputs.forEach($input => {
    $input.removeAttribute("readonly");
    $input.classList.remove("bg-light", "pe-none");
    // eslint-disable-next-line no-param-reassign
    $input.value = "0";
  });
};

const hideUploadButtons = () => {
  const $uploadButtons = $getAllUploadButtons();
  $uploadButtons.forEach($button => {
    $button.classList.add("d-none");
  });
};

const showUploadButtons = () => {
  const $uploadButtons = $getAllUploadButtons();
  $uploadButtons.forEach($button => {
    $button.classList.remove("d-none");
  });
};

const handleShipmentMissing = () => {
  const isShipmentMissing = isShipmentMissingScenario();

  if (isShipmentMissing) {
    setQuantityInputsForShipmentMissing();
    hideUploadButtons();
    wasShipmentMissing = true;
  } else if (wasShipmentMissing) {
    // Only reset quantities if we're leaving shipment missing mode
    resetQuantityInputs();
    showUploadButtons();
    wasShipmentMissing = false;
  }
};

const setSubcategoryOptions = options => {
  const $subcategorySelect = $getSubcategorySelect();
  $subcategorySelect.innerHTML = '<option value="">Select a subcategory</option>';

  Object.entries(options).forEach(([label, value]) => {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = label;
    $subcategorySelect.appendChild(option);
  });
};

const setSubcategorySelectState = isEnabled => {
  const $subcategorySelect = $getSubcategorySelect();
  $subcategorySelect.disabled = !isEnabled;
};

const handleCategoryChange = event => {
  const selectedCategory = event.target.value;
  const subcategories = $getSubcategories();

  if (selectedCategory) {
    const categorySubcategories = subcategories[selectedCategory];
    setSubcategorySelectState(true);
    setSubcategoryOptions(categorySubcategories);
  } else {
    setSubcategorySelectState(false);
    setSubcategoryOptions({});
  }

  handleShipmentMissing();
};

const handleSubcategoryChange = () => {
  handleShipmentMissing();
};

export default () => {
  const $categorySelect = $getCategorySelect();
  const $subcategorySelect = $getSubcategorySelect();

  if ($categorySelect) {
    $categorySelect.addEventListener("change", handleCategoryChange);
  }

  if ($subcategorySelect) {
    $subcategorySelect.addEventListener("change", handleSubcategoryChange);
    wasShipmentMissing = isShipmentMissingScenario();
    handleShipmentMissing();
  }
};
